app.service('searchShopManager', function(loading, broker) {
	const state = {
		shops: []
	};

	function getCollectionPoints(pointType, data) {
		const params = $.extend({ pointType }, data);
		return $.ajax({
			url: '/collection-points.ltr',
			dataType: 'json',
			data: params
		});
	}

	function getShop(code) {
		return state.shops.filter(shop => String(shop.code) === String(code));
	}

	function getShops() {
		return state.shops;
	}

	function getShopsBy(data) {
		return getCollectionPoints('shop', data);
	}

	function init() {
		loading.start();
		getCollectionPoints('shop')
			.then(shops => {
				loading.stop();
				state.shops = shops;
				broker.trigger('SEARCH_SHOP_INIT', [ shops ]);
			});
	}

	return {
		getShopsBy,
		getShops,
		getShop,
		init
	};
});